import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from 'actions'
import SelectNishitsunaisunLength from 'components/site/select_nishitsunaisun_length'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectNishitsunaisunLengthStart: state.searchFormCondition.selectNishitsunaisunLengthStart,
  selectNishitsunaisunLengthFinish: state.searchFormCondition.selectNishitsunaisunLengthFinish,
})

const NishitsunaisunLengthContainer = connect(mapStateToProps, mapDispatchToProps)(SelectNishitsunaisunLength)

export default NishitsunaisunLengthContainer
